import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { CustomerService } from './customer.service';

export const Ng1CustomerModule = angular
    .module('control-room.shared.services.customer', [])
    .factory('crCustomerService',downgradeInjectable(CustomerService));
